import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getClinicPartnerAvgFunctionalityQueryKey = () => ["getClinicPartnerAvgFunctionality"] as const;

export const useGetClinicPartnerAvgFunctionality = () => {
  const client = useApiClient();

  return useQuery(getClinicPartnerAvgFunctionalityQueryKey(), () => client.getClinicPartnerAvgFunctionality());
};
